import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { groundsClose, isGrounds, openAppShare, useMaximize, useNightMode } from './app';
import styles from './index.css';

const Header = ({ lightColor = '#ffffff', darkColor = '#222226', share = {} }) => {
    const statusBarHeight = useMaximize();
    const isNightMode = useNightMode();
    const headerRef = useRef(null);
    const [pinned, setPinned] = useState(false);

    useEffect(() => {
        let frame = 0;

        const onScroll = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
                const top = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
                const headHeight = headerRef.current ? headerRef.current.offsetHeight : 0;
                const nextPinned = headHeight > 0 && top > headHeight / 2;

                setPinned(prev => (prev === nextPinned ? prev : nextPinned));
            });
        };

        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });

        return () => {
            cancelAnimationFrame(frame);
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    const pinnedBackground = isNightMode ? darkColor : lightColor;
    const iconColor = isNightMode ? '#ffffff' : '#4D4D4D';
    const barSurfaceClassName = `${styles.surface} ${pinned ? styles.surfaceShow : ''}`;

    const handleBack = () => {
        if (isGrounds) {
            groundsClose();

            return;
        }

        if (window.history.length > 1) {
            window.history.back();
        }
    };

    const handleShare = () => {
        openAppShare({
            url: share.shareurl,
            title: share.title,
            desc: share.desc,
            thumbnail: share.thumb,
        });
    };

    return (
        <header className={styles.wrap} ref={headerRef}>
            <div className={styles.statusBar} style={{ height: statusBarHeight, backgroundColor: isNightMode ? darkColor : 'transparent' }}>
                {isNightMode ? null : <div className={barSurfaceClassName} style={{ backgroundColor: lightColor }} />}
            </div>
            <div className={styles.bar} style={{ color: iconColor }}>
                <div className={barSurfaceClassName} style={{ backgroundColor: pinnedBackground }} />
                <div className={styles.back} onClick={handleBack} />
                {pinned && <div className={styles.title}>2026年美国中期选举</div>}
                <div className={styles.share} onClick={handleShare} />
            </div>
        </header>
    );
};

Header.propTypes = {
    lightColor: PropTypes.string,
    darkColor: PropTypes.string,
    share: PropTypes.shape({
        shareurl: PropTypes.string,
        title: PropTypes.string,
        desc: PropTypes.string,
        thumb: PropTypes.string,
    }),
};

export default errorBoundary(Header);
